import axios, { CancelTokenSource } from 'axios'
import {
  ISubleaseFilters,
  SubleaseDecisionTypes,
  SubleaseSortFieldEnum,
  SubleaseSortOrderEnum,
  SubleaseStatusEnum,
} from '../models/Sublease'

export const getSubleases = (
  clientId: string,
  filters: ISubleaseFilters,
  source?: CancelTokenSource
) => {
  const body = {
    ...filters,
    sortColumn: filters.sortColumn || SubleaseSortFieldEnum.status,
    sortorder: filters.sortorder || SubleaseSortOrderEnum.asc,
  }
  return axios.post(`sublease/${clientId}/applications/query`, body, {
    cancelToken: source?.token,
    headers: {
      'x-api-version': '1.0',
      'Content-type':
        'application/json;odata.metadata=minimal;odata.streaming=true',
    },
  })
}

export const getSublease = (id: string) => {
  return axios.get(`sublease/application/${id}/details`)
}

export const addApplicationDecision = (
  id: string,
  comment: string,
  decision: SubleaseDecisionTypes,
  lastUpdate: Date
) => {
  return axios.post(
    `sublease/application/${id}/decision`,
    {
      decision:
        decision === 'approve'
          ? SubleaseStatusEnum.approved
          : SubleaseStatusEnum.rejected,
      decisionComment: comment || '',
      lastUpdate: lastUpdate,
    },
    {
      headers: {
        'x-api-version': '1.0',
      },
    }
  )
}

export const deleteApplicationDecision = (id: string) => {
  return axios.delete(`sublease/application/${id}/decision`)
}

export const changeSubleaseEndDate = (
  id: string,
  newDate: Date,
  comment: string
) => {
  return axios.put(`sublease/application/${id}/enddate`, {
    newEnddate: newDate,
    comment: comment,
  })
}

export const getExpiredTenants = (
  clientId: string,
  expireWithinDays: number,
  sortColumn = 'ToDate',
  sortOrder = 'Ascending'
) => {
  return axios.post(`sublease/clients/${clientId}/tenants`, {
    maxDaysUntilUpcomingEndDate: expireWithinDays,
    sortColumn: sortColumn,
    sortOrder: sortOrder,
  })
}

export const getTenantsHistoryInUnit = (
  unitId: string,
  periodFrom: Date,
  sortColumn = 'FromDate',
  sortOrder = 'Descending',
  currentOwnerOnly = true,
  statuses = 'All'
) => {
  return axios.post(`sublease/units/${unitId}/tenants`, {
    status: statuses,
    periodFrom: periodFrom,
    onlySubleasesForCurrentOwners: currentOwnerOnly,
    sortColumn: sortColumn,
    sortOrder: sortOrder,
  })
}

export const getSubleaseSettings = (clientId: string) => {
  return axios.get(`sublease/clients/${clientId}/settings`)
}
